import { render, staticRenderFns } from "./Interconsulta.vue?vue&type=template&id=042fc886"
import script from "./Interconsulta.vue?vue&type=script&lang=js"
export * from "./Interconsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports